const isValidEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const lengthIsShorterThan = (string, len) => string.length < len;
const lengthIsGreaterThan = (string, len) => string.length > len;
const isPasswordValid = password => password.length >= 6;

export { isValidEmail, lengthIsShorterThan, lengthIsGreaterThan, isPasswordValid };
